import { render, staticRenderFns } from "./OtherReports.vue?vue&type=template&id=019c5e63"
import script from "./OtherReports.vue?vue&type=script&lang=js"
export * from "./OtherReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports